import React, { useState } from 'react';
import api from '../../../../../../services/api';
import { useToast } from '../../../../../../hooks/Toast';
import { Upload } from 'tus-js-client';
import { useAuth } from '../../../../../../hooks/Auth';
import { FiSend, FiUpload } from 'react-icons/fi';
import { useConfiguration } from '../../../../../../hooks/Configuration';
import { useModal } from '../../../../../../hooks/Modal';

interface ICreateModule {
  lineData: Record<string, any>;
}


const VideoUpload = ({ project_id }) => {
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [uploadProgress, setUploadProgress] = useState({});
  const [uploading, setUploading] = useState(false);
  const [errors, setErrors] = useState({});
  const { addToast } = useToast();
  const handleFileChange = (event) => {
    setSelectedFiles(event.target.files);
  };

  const handleUpload = async () => {
    if (selectedFiles.length === 0) return;

    setUploading(true);
    setErrors({});

    try {
      const checkVideoLibrary = await api.get(`/check-video-upload-library/${project_id}`);

    }
    catch (err) {

      addToast({ title: 'Erro ao validar galeria', type: 'error' });
      return;
    }


    Array.from(selectedFiles).forEach(async (file: File, index) => {
      const startUpload = await api.post(`/start_video_upload/${project_id}`, { title: file?.name });
      const upload = new Upload(file, {
        endpoint: "https://video.bunnycdn.com/tusupload",
        retryDelays: [0, 3000, 5000, 10000, 20000, 60000, 60000],
        headers: {
          AuthorizationSignature: startUpload?.data?.authorization, // Replace with your SHA256 signature
          AuthorizationExpire: startUpload?.data?.expiration, // Replace with the expiration time
          VideoId: startUpload?.data?.video_id, // Replace with your video GUID
          LibraryId: startUpload?.data?.library_id, // Replace with your Library ID
        },
        metadata: {
          filetype: file.type,
          title: file.name,
          collection: "" // Replace with your collection ID
        },
        onError: function (error) {
          console.error('Upload failed:', error);
          setErrors((prevErrors) => ({ ...prevErrors, [index]: error.message }));
          setUploading(false);
        },
        onProgress: function (bytesUploaded, bytesTotal) {
          const progress = Math.round((bytesUploaded / bytesTotal) * 100);
          setUploadProgress((prevProgress) => ({ ...prevProgress, [index]: progress }));
        },
        onSuccess: function () {
          console.log('Upload successful:', upload.url);
          setUploading(false);
        }
      });

      upload.findPreviousUploads().then(function (previousUploads) {
        if (previousUploads.length) {
          upload.resumeFromPreviousUpload(previousUploads[0]);
        }
        upload.start();
      });
    });
  };

  return (
    <div style={{ maxWidth: '600px', margin: '0 auto', textAlign: 'center' }}>
      <h3>Upload Videos to Bunny.com</h3>
      <input type="file" accept="video/*" multiple onChange={handleFileChange} />
      {selectedFiles.length > 0 && (
        <div style={{ marginTop: '20px' }}>
          <button onClick={handleUpload} disabled={uploading}>
            {uploading ? 'Uploading...' : 'Upload'}
          </button>
        </div>
      )}
      {Array.from(selectedFiles).map((file: File, index) => (
        <div key={index} style={{ marginTop: '20px' }}>
          <div>{file.name}</div>
          {uploading && uploadProgress[index] !== undefined && (
            <div>
              <progress value={uploadProgress[index]} max="100"></progress>
              <div>{uploadProgress[index]}%</div>
            </div>
          )}
          {errors[index] && (
            <div style={{ color: 'red' }}>
              <p>Upload failed: {errors[index]}</p>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};



export default function UpdateModule(): JSX.Element {
  const { configuration } = useConfiguration();
  const { addToast } = useToast();
  const { addModal } = useModal();




  const handleSend = async (): Promise<void> => {
    addModal({ title: '', content: <VideoUpload project_id={configuration?.url} />, theme: 'whiteModal', })
  };

  const moduleUpdate = (): JSX.Element => (
    <button className="lineIcon" title="UploadManager" type="button" onClick={() => handleSend()}>
      <FiUpload />
    </button>
  );

  return moduleUpdate();
}
